module.exports = __webpack_public_path__ + "media/munches/big-ol-chomper-2-965a6b76.svg";